var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex space-x-56 max-h-fit"},[_c('div',{staticClass:"lg:mt-2 sm:mt-0 w-full"},_vm._l((_vm.formattedFaqs),function(item,idx){return _c('FaqAccordion',{key:idx,attrs:{"cardDetails":item}})}),1)])}
var staticRenderFns = []

export { render, staticRenderFns }